export const siteInfo = {
  name: '911爆料网',
  nameEn: '911 Expose',
  tagline: '吃瓜黑料第一站',
  description: '911爆料网是国内领先的娱乐八卦资讯平台，每日实时更新网红翻车、明星八卦、反差视频等热门大瓜，为吃瓜群众提供最新最全的黑料资讯。',
  logo: '911',
  foundedYear: '2020',
  email: 'tips@4xhyp.com',
  wechat: '911baoliao',
  weibo: '@911爆料网',
  stats: {
    dailyVisitors: '500万+',
    totalArticles: '10万+',
    verifiedTips: '3万+',
  },
};
